import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { OPPORTUNITIES_API_PATHS } from 'src/constants/urlPathAndQueryParams';
import axios from '../utils/APIUtils';

export const opportunitiesList = createAsyncThunk(
  'landingPage/opportunitiesList',
  async (args: any, store) => {
    const {
      landingPage: {
        opportunityList: { metadata },
      },
      onBoarding: { currentRole },
    } = store.getState() as RootState;

    const postData = {
      page: metadata.page,
      rows_per_page: metadata.page_limit,
      sort: metadata.sort,
      filters: metadata.filters,
      current_role: currentRole,
      ...args,
    };

    const response = await axios.post<any>(
      OPPORTUNITIES_API_PATHS.opportunities,
      postData
    );
    return response.data;
  }
);

export const getModelLabelData = createAsyncThunk(
  'landingPage/modelStageDetailsNotify',
  async (args: any, store) => {
    const {
      context: {
        modelCenterData: { metadata },
      },
      onBoarding: { currentRole }
    } = store.getState() as RootState;

    const response = await axios.post<any>(
      `${OPPORTUNITIES_API_PATHS.labelModels}?current_role=${currentRole}`
    );
    return response.data;
  }
)

export const initialState = {
  opportunityList: {
    metadata: {
      page: 1,
      page_limit: 3,
      total_row_count: 0,
      sort: {},
      filters: [],
    },
    opportunity_detail: [],
    loading: true,
    error: false,
    errorMsg: '',
  },
  currentModel:"",
  modelCenterData: {
    metadata: { page: 1, page_limit: 10, total_row_count: 0, sort: {} },
    model_details: [],
    loading: true,
    error: false,
    errorMsg: '',
  },
};

export const landingPageSlice = createSlice({
  name: 'landingPage',
  initialState,
  reducers: {
    setCurrentModel: (state, action) => {
      state.currentModel = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(opportunitiesList.pending, (state) => {
      return {
        ...state,
        opportunityList: {
          ...state.opportunityList,
          loading: true,
          error: false,
        },
      };
    });
    builder.addCase(
      opportunitiesList.fulfilled,
      (state, { payload: { metadata, opportunity_detail } }) => {
        return {
          ...state,
          opportunityList: {
            ...state.opportunityList,
            metadata: { ...state.opportunityList.metadata, ...metadata },
            opportunity_detail: opportunity_detail ?? [],
            loading: false,
          },
        };
      }
    );
 
    builder.addCase(opportunitiesList.rejected, (state) => {
      return {
        ...state,
        opportunityList: {
          ...state.opportunityList,
          loading: false,
          error: true,
          errorMsg: 'Something went wrong!',
        },
      };
    });

    builder.addCase(getModelLabelData.pending, (state) => {
      return {
        ...state,
        modelCenterData: {
          ...state.modelCenterData,
          loading: true,
          error: false,
        },
      };
    });
    builder.addCase(
      getModelLabelData.fulfilled,
      (state, { payload: { metadata, model_details } }) => {
        return {
          ...state,
          modelCenterData: {
            ...state.modelCenterData,
            metadata: { ...state.modelCenterData.metadata, ...metadata },
            model_details: model_details ?? [],
            loading: false,
          },
        };
      }
    );
    builder.addCase(getModelLabelData.rejected, (state) => {
      return {
        ...state,
        modelCenterData: {
          ...state.modelCenterData,
          loading: false,
          error: true,
          errorMsg: 'Something went wrong!',
        },
      };
    });


  },
});

export const { setCurrentModel}=  landingPageSlice.actions;

export const getCurrentModel = (state: RootState) => state.landingPage.currentModel;

export const getLandOpportunity = (state: RootState) =>
  state.landingPage.opportunityList;
 
  export const getModallabelDataValue = (state: RootState) =>
  state.landingPage.modelCenterData;


export default landingPageSlice.reducer;
